import { useNavigate } from 'react-router-dom';
import useSearchString from '../useSearchString';
import { FILTER_PARAMS } from '../../constants/filters';

const useFilter = (allValue = FILTER_PARAMS.all) => {
  const navigate = useNavigate();

  const { setParamByName, getAsObject, getAsString } = useSearchString();

  const setFilter = (key: string, value: string | null) => {
    setParamByName(key, value === allValue ? null : value);
    navigate(`?${getAsString()}`);
  };

  const clearFilter = (exclude: string[] = []) => {
    const filterObject = getAsObject();
    Object.keys(filterObject).forEach((item) => {
      if (!exclude.includes(item)) {
        setParamByName(item, null);
      }
    });
    navigate(`?${getAsString()}`);
  };

  return {
    filter: getAsObject(),
    setFilter,
    clearFilter
  };
};

export default useFilter;
